// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'vend... Remove this comment to see the full error message
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

import { DEFAULT_PROTOCOL } from 'bundles/widget-simulator/constants';
import uuid from 'bundles/widget-simulator/utils/uuid';

const WidgetSimulatorStore = createStore({
  storeName: 'WidgetSimulatorStore',
  showFrame: true,
  refreshTime: Date.now(),
  session: undefined,
  manifest: undefined,
  log: [],
  answer: undefined,
  submittedAnswer: undefined,
  evaluation: undefined,
  defaultCourseScopeId: uuid(),
  defaultPluginScopeId: uuid(),
  defaultSessionConfigId: uuid(),

  initialize() {
    this.clearLog();
  },

  clearLog() {
    this.log = [];
    this.runId = uuid();
  },

  getRefreshTime() {
    return this.refreshTime;
  },

  clearAnswer() {
    this.answer = undefined;
    this.submittedAnswer = undefined;
    this.evaluation = undefined;
  },

  getAnswer() {
    return this.answer;
  },

  getSubmittedAnswer() {
    return this.submittedAnswer;
  },

  getEvaluation() {
    return this.evaluation;
  },

  getManifest() {
    return {
      ...this.manifest,
      simulator: {
        ...(this.manifest && this.manifest.simulator),
        scope: {
          courseId: this.getCourseScopeId(),
          pluginId: this.getPluginScopeId(),
          instanceId: this.getSessionConfigId(),
        },
        sessionId: 'simulator-session', // TODO use a proper sessionId
      },
    };
  },

  getIsSessionLoaded() {
    return !!this.session;
  },

  getRpcActionLog() {
    return this.log;
  },

  getProtocol() {
    return (this.session && this.session.protocol) || DEFAULT_PROTOCOL;
  },

  getUrlPrefix() {
    return `${this.getProtocol()}://`;
  },

  getUrl() {
    return this.session && this.session.url;
  },

  getFullUrl() {
    return this.getUrl() && this.getUrlPrefix() + this.getUrl();
  },

  getSelectedCourseScope() {
    return this.session && this.getCourseScopes()[this.session.scope.course.selectedIndex];
  },

  getCourseScopeId() {
    const scope = this.getSelectedCourseScope();
    return scope ? scope.id : this.defaultCourseScopeId;
  },

  getCourseScopes() {
    return this.session && this.session.scope.course.options;
  },

  getSelectedPluginScope() {
    return this.session && this.getPluginScopes()[this.session.scope.plugin.selectedIndex];
  },

  getPluginScopeId() {
    const scope = this.getSelectedPluginScope();

    if (scope) {
      return scope.id || this.defaultPluginScopeId;
    } else {
      return (this.manifest && this.manifest.name) || this.defaultPluginScopeId;
    }
  },

  getPluginScopes() {
    return this.session && this.session.scope.plugin.options;
  },

  getSelectedSessionConfig() {
    return this.session && this.getSessionConfigs()[this.session.sessionConfig.selectedIndex];
  },

  getCombinedSessionConfig() {
    if (!this.session) {
      return undefined;
    }

    const { evaluation } = this;
    const sessionConfig = this.getSelectedSessionConfig();
    const feedbackConfiguration = evaluation && evaluation.feedbackConfiguration;

    return {
      ...(sessionConfig && sessionConfig.config),
      ...feedbackConfiguration,
    };
  },

  getSessionConfigId() {
    const config = this.getSelectedSessionConfig();
    return config ? config.id : this.defaultSessionConfigId;
  },

  getSessionConfigs() {
    return this.session && this.session.sessionConfig.options;
  },

  getSelectedGraderConfig() {
    return this.session && this.getGraderConfigs()[this.session.graderConfig.selectedIndex];
  },

  getGraderConfigs() {
    return this.session && this.session.graderConfig.options;
  },

  shouldShowFrame() {
    return this.showFrame;
  },

  updateLoggedAction(id: $TSFixMe, updateFn: $TSFixMe) {
    const index = this.log.findIndex((action: $TSFixMe) => action.id === id);

    if (index === -1) {
      return;
    }

    this.log[index] = updateFn(this.log[index]);
    this.emitChange();
  },
});

WidgetSimulatorStore.handlers = {
  SIMULATOR_RESET_APP() {
    this.clearLog();
    this.clearAnswer();
    this.showFrame = false;
    this.emitChange();
  },

  SIMULATOR_SET_MANIFEST({ manifest }: $TSFixMe) {
    this.manifest = manifest;
    this.emitChange();
  },

  SIMULATOR_SET_ANSWER({ answer }: $TSFixMe) {
    this.answer = answer;
    this.emitChange();
  },

  SIMULATOR_SUBMIT_FOR_GRADING() {
    this.submittedAnswer = this.answer;
    this.evaluation = this.submittedAnswer.evaluation;
    this.emitChange();
  },

  SIMULATOR_SET_EVALUATION({ evaluation }: $TSFixMe) {
    this.evaluation = evaluation;
    this.emitChange();
  },

  SIMULATOR_CLEAR_ANSWER() {
    this.clearAnswer();
    this.emitChange();
  },

  SIMULATOR_SET_SESSION({ session }: $TSFixMe) {
    this.session = session;
    this.emitChange();
  },

  SIMULATOR_RELOAD_FRAME() {
    this.log.push({ id: uuid(), name: 'DIVIDER' });
    this.showFrame = false;
    this.emitChange();
  },

  SIMULATOR_FRAME_UNMOUNTED() {
    this.showFrame = true;
    this.refreshTime = Date.now();

    if (this.log && this.log.length === 1 && this.log[0].name === 'DIVIDER') {
      this.log = [];
    }

    this.emitChange();
  },

  SIMULATOR_LOG_ACTION({ id, time, name, type, description, request, response }: $TSFixMe) {
    this.log.push({ id, name, type, time, description, request, response });
    this.emitChange();
  },

  SIMULATOR_UPDATE_LOGGED_ACTION({ id, newProps }: $TSFixMe) {
    this.updateLoggedAction(id, (action: $TSFixMe) => ({
      ...action,
      ...newProps,
    }));
  },

  SIMULATOR_ADD_LOGGED_ACTION_ERRORS({ id, errors }: $TSFixMe) {
    this.updateLoggedAction(id, (action: $TSFixMe) => {
      return {
        ...action,
        errors: [...(action.errors || []), ...errors],
      };
    });
  },

  SIMULATOR_CLEAR_LOG() {
    this.clearLog();
    this.emitChange();
  },
};

export default WidgetSimulatorStore;
